/* UNHERD · Luxe interactions: clickable ratings + size guide → accordion */
(function () {
  function headerOffset() {
    var h = document.querySelector('.js-sticky-header, header, .header');
    return (h ? h.getBoundingClientRect().height : 0) + 16;
  }
  function smoothTo(el) {
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
  function reviewsTarget() {
    return document.getElementById('uh-reviews') || document.querySelector('.jdgm-review-widget, .jdgm-rev-widg, #judgeme_product_reviews');
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-uh-scroll], .jdgm-preview-badge, .jdgm-widget.jdgm-preview-badge');
    if (a) {
      var t = reviewsTarget();
      if (t) { e.preventDefault(); smoothTo(t); }
      return;
    }
    var o = e.target.closest('[data-uh-open]');
    if (o) {
      var d = document.getElementById(o.getAttribute('data-uh-open'));
      if (d) {
        e.preventDefault();
        d.open = true;
        smoothTo(d);
        d.classList.remove('uh-acc__flash'); void d.offsetWidth; d.classList.add('uh-acc__flash');
      }
    }
  });
  if (location.hash === '#uh-reviews' || location.hash === '#judgeme_product_reviews') {
    window.addEventListener('load', function () { setTimeout(function () { smoothTo(reviewsTarget()); }, 300); });
  }
})();

/* Cart drawer app (shadow DOM): keep milestone labels on one line */
(function () {
  var CSS = '.cart-reward-milestone-title{display:none!important}' +
            '.cart-reward-milestones{overflow:visible!important}';
  function patch() {
    document.querySelectorAll('section-store--cart-block').forEach(function (h) {
      var r = h.shadowRoot;
      if (r && !r.querySelector('style[data-uh]')) {
        var st = document.createElement('style'); st.setAttribute('data-uh', ''); st.textContent = CSS; r.appendChild(st);
      }
    });
  }
  new MutationObserver(patch).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', patch); patch();
})();
